import { rem } from 'polished';

import { Theme } from '../../../theme';
import { InputSize, InputThemeVariantValues } from '../types';

import mapInputSizeToThemeSize from './mapInputSizeToThemeSize';

const getThemeInputVariant = (
  theme: Theme,
  size: InputSize = 'large',
): InputThemeVariantValues => {
  const variant = theme.components.Input.regular[mapInputSizeToThemeSize(size)];

  if (size === 'small') {
    // our "small" variant on FE does not exist in figma tokens, so we create override for it
    // note: in future this logic will be moved to theme mapper
    return {
      ...variant,
      'horizontal-padding': rem(8),
      'vertical-padding': rem(0),
      radius: rem(4),
    };
  }

  return variant;
};

export default getThemeInputVariant;
